import React, { useState, useEffect, useRef } from 'react'
import { useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import { Form } from "reactstrap";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import HomeIcon from '@material-ui/icons/Home';
import Swal from 'sweetalert2'
import 'tui-grid/dist/tui-grid.css';
import Grid from '@toast-ui/react-grid';
import 'tui-pagination/dist/tui-pagination.css';

import { DatePicker, Space, ConfigProvider } from 'antd';
import locale from 'antd/locale/ko_KR';
import { useStoresIpgo } from '../UseStores/UseStore';

import '../Shared/Css/IpgoIndex.css';
import IpgoCreate from "./IpgoCreate";
import IpgoEdit from "./IpgoEdit";
import IpgoDelete from "./IpgoDelete";
import IpgoError from './Message/IpgoErrorMessage';
import IpgoEsave from './Message/IpgoSaveMessage';


function IpgoIndex() {
  const gridRef = useRef();
  const [data, setData] = useState([]); //데이터 가저오기
  const [pwloading, setPwLoading] = useState(); //실행시 한번만 권한가지기
  const [urlpw, setUrlpw] = useState(); //실행시 매번 권한가져오기
  const [customer, setCustomer] = useState([]); //selectPicker 데이터 가저오기
  const [valueSelectPicker, setValueSelectPicker] = useState(); //selectPicker 데이터 가저오기
  const [ondatestart, setOnDateStart] = useState(); //검색등록시작일자
  const [ondateend, setOnDateEnd] = useState(); //검색등록시작일자
  const [editValue, setEditValue] = useState(); //그리드 틀릭 수정
  const [add, setAdd] = useState(false); //테이터등록모달
  const [editmodal, setEditModal] = useState(false); //데이터수정모달
  const [delmodal, setDelmodal] = useState(false); //데이터삭제모달
  const [dbOpen, setDbOpen] = useState(false); //모달데이카베이스 다시 실행 스테이트
  let [eerror, setEerror] = useState(false); //에라메세지 모달
  let [esave, setEsave] = useState(false); //저장메세지 모달
  //let [clickValue, setClickValue] = useState(false); //토스트 클릭시 자됴담기

  //히스토리사용
  const history = useHistory();

  //zustend 스테이트 사용 설정
  // const { ipgoprintopentrue,ipgoprintopenhangmok,ipgoprintopenquality} = useStores(); 


  //세션복고화시작
  const pwBog = () => {
    const pwNo = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    //console.log(pwNo);
    pwNo > 0 ? setPwLoading(pwNo) : setPwLoading();
  }
  useEffect(() => {
    pwBog()
  }, [pwloading])

  const pwLogin = () => {
    const pwNoPlus = parseInt(sessionStorage.getItem('100') - 660620); //사번복구화
    setUrlpw(pwNoPlus)
  }
  useEffect(() => {
    pwLogin()
  }, [urlpw])

  // console.log(`초기값: ${pwloading}`)
  // console.log(`변경값:${urlpw}`)

  const urlExquate = () => {
    //window.location.href = '/AcountLogin/Login';
    window.location.assign('/AcountLogin/Login');
  };
  //사번복고화 종료

  const getJsonLoad = async () => {
    setData([])
    await axios.get("/IpgoReact/Index")
      .then((res) => {
        setData(res.data)
        //console.log(res);
      })
  };
  //fatch api 방식
  //   const getJsonLoad1 = async () => {
  //     const response = await fetch(`/IpgoReact/index`);
  //     const data = await response.json();
  //     setData(data);
  // }

  //업체찾기
  const GetSelectCustomer = async () => {
    await axios.get("/IpgoReact/UpcheMasterIndex")
      .then((res) => {
        setCustomer(res.data)
      })
  };

  useEffect(() => {
    GetSelectCustomer();
    getJsonLoad();
    setOnDateStart();
    setOnDateEnd();
    setDbOpen(false);
    console.log('재랜드링됨')
  }, [dbOpen]);

  //new Grid option 설정부분
  const columns = (
    [
      {
        name: "edit", header: "수정", align: "center", width: 50,
        formatter: () => {
          return '<i class="fas fa-edit" style="font-size:17px;color:forestgreen;"></i>';
          //return '<button type="button" class="btn btn-outline-primary btn-sm">수정</button>';
        }
      },
      {
        name: "print", header: "인쇄", align: "center", width: 50,
        formatter: () => {
          return '<i class="fas fa-print" style="font-size:17px;color:blue;"></i>';
        }
      },
      { name: "ipgo_item_upche_sangho", header: "업체", align: "left", width: 100 },
      { name: "ipgo_factory", header: "공장구분", align: "center", width: 68 },
      { name: "ipgo_item_auto", header: "작지", align: "center", width: 50 },
      { name: "ipgo_item_bel_meng", header: "별명", align: "left", width: 60 },
      { name: "ipgo_item", header: "우리품번", align: "center", width: 66 },
      { name: "ipgo_item_upche_item", header: "업체품번", align: "left", width: 130, className: 'gross-color', },
      { name: "ipgo_item_upche_name", header: "품명", align: "left", width: 163 },
      { name: "ipgo_gress_weight", header: "단중", align: "left", width: 60 },
      {
        name: "ipgo_dangrang", header: "당량", align: "right", width: 50,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      { name: "ipgo_item_cheri_desc", header: "시작공정", align: "left", width: 85 },
      { name: "ipgo_item_cheri_code", header: "종료", align: "center", width: 50 },
      { name: "ipgo_item_work_cheri_line", header: "피막라인", align: "center", width: 76 },
      { name: "ipgo_item_danga", header: "S단가", align: "right", width: 50 },
      { name: "ipgo_item_daewi", header: "P단위", align: "center", width: 50 },
      { name: "ipgo_item_danga_pimac", header: "P단가", align: "right", width: 50 },
      { name: "ipgo_item_do_danwie", header: "D단위", align: "center", width: 50 },
      { name: "ipgo_item_danga_dopo", header: "D단가", align: "right", width: 50 },
      {
        name: "ipgo_item_quantity", header: "입고수량", align: "right", width: 92,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      { name: "ipgo_ticket_jundal", header: "입고Box", align: "center", width: 70 },
      { name: "ipgo_upche_lot_code", header: "업체로트", align: "center", width: 70 },
      { name: "ipgo_item_description", header: "전달사항", align: "left", width: 125 },
      { name: "ipgo_item_yn", header: "진행", align: "center", width: 60 },

      {
        name: "ipgo_item_datetime", header: "입고일자", align: "center", width: 105,
        formatter: function (ev) {
          return `${moment(ev.value).format('YYYYMMDD HH:mm')}`
        }
      },
      { name: "ipgo_item_user", header: "등록자", align: "center", width: 70 },
      {
        name: "ipgo_피막금액", header: "P금액", align: "right", width: 90,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "ipgo_도포금액", header: "D금액", align: "right", width: 90,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      {
        name: "ipgo_합계금액", header: "S금액", align: "right", width: 90,
        formatter: function (ev) {
          return `${ev.value.toLocaleString('ko-KR')}`
        }
      },
      { name: "ipgo_공용품번", header: "특별공정", align: "center", width: 70 },
      { name: "ipgo_최종공정라인", header: "최종공정", align: "left", width: 250 },
      { name: "ipgo_item_qc_inspection", header: "합부", align: "center", width: 50 },
      { name: "ipgo_item_qc_gumsuja", header: "검수", align: "center", width: 50 },
      { name: "ipgo_upche_code", header: "C코드", align: "center", width: 50 },
      { name: "ipgo_item_price_sangtae", header: "단가상태", align: "center", width: 70 },
      { name: "ipgo_ipgojangso", header: "입고장소", align: "center", width: 70 },
      { name: "ipgo_wi_chi", header: "보관장소", align: "center", width: 70 },
      { name: "ipgo_공장간이동전표출력", header: "출력2", align: "center", width: 50 },
      { name: "ipgo_item_editja", header: "수정자", align: "center", width: 70 },
      {
        name: "delete", header: "삭제", align: "center", width: 50,
        formatter: () => {
          return '<i class="fas fa-trash-alt" style="font-size:17px;color:red;"></i>';
        }
      },
    ]
  );

  //번호, 체크박스 설정부분
  const rowHeaders = [
    { type: 'rowNum' },
    //{type: 'checkbox'},
  ];

  const rows = data.map((row) => ({
    //id: row.id,
    edit: '수정',
    print: '인쇄',
    ipgo_item_upche_sangho: row.ipgo_item_upche_sangho,
    ipgo_factory: row.ipgo_factory,
    ipgo_item_auto: row.ipgo_item_auto,
    ipgo_item_bel_meng: row.ipgo_item_bel_meng,
    ipgo_item: row.ipgo_item,
    ipgo_item_upche_item: row.ipgo_공용품번 ? (row.ipgo_item_upche_item + " [" + row.ipgo_공용품번 + "]") : row.ipgo_item_upche_item,
    ipgo_item_upche_name: row.ipgo_item_upche_name,
    ipgo_gress_weight: row.ipgo_gress_weight,
    ipgo_dangrang: row.ipgo_dangrang,
    ipgo_item_cheri_desc: row.ipgo_item_cheri_desc,
    ipgo_item_cheri_code: row.ipgo_item_cheri_code,
    ipgo_item_work_cheri_line: row.ipgo_item_work_cheri_line,
    ipgo_item_danga: row.ipgo_item_danga,
    ipgo_item_daewi: row.ipgo_item_daewi,
    ipgo_item_danga_pimac: row.ipgo_item_danga_pimac,
    ipgo_item_do_danwie: "Ea",
    ipgo_item_danga_dopo: row.ipgo_item_danga_dopo,
    ipgo_item_price_sangtae: row.ipgo_item_price_sangtae,
    ipgo_item_quantity: row.ipgo_item_quantity,
    ipgo_upche_lot_code: row.ipgo_upche_lot_code, //입고업체로트번호
    ipgo_ticket_jundal: row.ipgo_ticket_jundal,
    ipgo_item_description: row.ipgo_item_description,
    ipgo_item_yn: row.ipgo_item_yn,
    ipgo_item_datetime: row.ipgo_item_datetime,
    ipgo_item_user: row.ipgo_item_user,
    ipgo_피막금액: row.ipgo_item_danga_pimac * row.ipgo_item_quantity, //피막금액
    ipgo_도포금액: row.ipgo_item_danga_dopo * row.ipgo_item_quantity,  //도포금액
    ipgo_합계금액: row.ipgo_item_danga * row.ipgo_item_quantity,  //합계금액
    ipgo_공용품번: row.ipgo_공용품번,
    ipgo_최종공정라인: row.ipgo_최종공정라인,
    ipgo_item_qc_inspection: row.ipgo_item_qc_inspection,
    ipgo_item_qc_gumsuja: row.ipgo_item_qc_gumsuja,
    ipgo_upche_code: row.ipgo_upche_code,
    ipgo_ipgojangso: row.ipgo_ipgojangso, //입고장소[하역장소]
    ipgo_wi_chi: row.ipgo_wi_chi, //입고창고위치
    ipgo_공장간이동전표출력: row.ipgo_공장간이동전표출력, //공장간이동전표출력
    ipgo_item_editja: row.ipgo_item_editja, //작업일보수정자
    delete: '삭제'
  }));

  //그리드 합계부분
  const summary = {
    height: 30,
    position: 'bottom', // or 'top'
    columnContent: {
      edit: {
        template(summary) {
          return '<div align="center">합계</div>';
        }
      },
      ipgo_item_quantity: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      ipgo_피막금액: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      ipgo_도포금액: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
      ipgo_합계금액: {
        template(summary) {
          return `<div align="right">${summary.sum.toLocaleString('ko-KR')}</div>`;
        }
      },
    },
  };


  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require('tui-grid');
  Gr.setLanguage('ko');
  Gr.applyTheme('striped', {
    frozenBorder: {
      border: 'red',
    },
    outline: {
      //border: 'blue',
      showVerticalBorder: true,
    },
    cell: {
      normal: {
        background: 'pink',
        border: '#DCDCDC',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },

      header: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true
      },
      rowHeader: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      selectedRowHead: {
        background: '#e5f6ff',
        showVerticalBorder: true
      },
      summary: {
        background: '#DCDCDC',
        border: '#C0C0C0',
        text: 'blue',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },

    area: {
      header: {
        border: '#59b9ea',
        background: 'silver',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      body: {
        border: 'red',
        background: 'white',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      summary: {
        border: '#59b9ea',
        background: 'silver',
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },
    //호버설정
    row: {
      hover: {
        background: 'silver'
      }
    },
  });

  //selectPicker 데이타뿌리기
  const selectData = customer.map(
    item => ({ label: item.upche_sanghoupche_sangho, value: item.upche_code })
  );

  //클릭스 수정이벤트
  const handleClick = (ev) => {
    var rowKey = ev.rowKey
    const clickValue = gridRef.current.getInstance().getRow(ev.rowKey)
    //console.log(clickValue);
    if (ev.rowKey === rowKey && ev.columnName === 'edit') {
      //console.log('잘처리됨');
      //console.log(clickValue.ipgo_item_upche_sangho);console.log(clickValue.t01);console.log(clickValue.t02);console.log(clickValue.t03);
      // console.log(clickValue);
      setEditValue(clickValue);
      setEditModal(true);
    }
    //사진가져오기
    else if (ev.rowKey === rowKey && ev.columnName === 'ipgo_item_upche_item') {
      axios.get(`/IpgoReact/ItemImgIndex?ItemSabun=${clickValue.ipgo_item}`)
        .then((res) => {
          if (res.status === 200) {
            const imgitem = res.data;
            Swal.fire({
              title: `품번:${imgitem[0].file_bul}[${clickValue.ipgo_item_upche_item}]`,
              //text: 'Modal with a custom image.',
              imageUrl: `data:image/png;base64, ${imgitem[0].file}`,
              confirmButtonText: '나가기',
              imageWidth: 400,
              imageHeight: 250,
              imageAlt: 'Ok',
            })
          }
        })
        .catch(error => {
          console.log(`에라발생:${error}`)
        })
    }

    else if (ev.rowKey === rowKey && ev.columnName === 'print') {
      useStoresIpgo.setState({ ipgoprintopentrue: true }) //주스텐드 ture 스테이트 변경
      useStoresIpgo.setState({ ipgoprintopenhangmok: clickValue }) //주스텐드 스테이터로 자료담기

      axios.get(`/IpgoReact/IndexWorkGumSahangmok?Gumsahangmok=${clickValue.ipgo_item_auto}`)
        .then((res) => { useStoresIpgo.setState({ ipgoprintopenquality: res.data[0] }) })
      // console.log(ipgoprintopentrue)
      //console.log(ipgoprintopenhangmok)
      // console.log(ipgoprintopenquality)
      history.push('/Ipgo/IpgoPrint');

    }
    else if (ev.rowKey === rowKey && ev.columnName === 'delete') {

      setEditValue(clickValue);
      setDelmodal(true);
    }
    else {
      console.log('Grid 처리필드가 아님');
    }
  };

  //console.log(ipgoprintopentrue)
  //console.log(ipgoprintopenhangmok)

  ////폼 전송실행 함수(조건찾기)
  const handleSubmit = (event) => {
    event.preventDefault();
    const evValue = new FormData(event.currentTarget);
    const valueCustomer = valueSelectPicker.value ? valueSelectPicker.value : "%";     //업체코드
    const valueIpgodateStart = ondatestart ? moment(ondatestart).format('YYYY-MM-DD') : '%'  //등록검색시작일
    const valueIpgodateEnd = ondateend ? moment(ondateend).format('YYYY-MM-DD') : '%'  //등록검색종료일
    const valueBulname = evValue.get("bulname") ? evValue.get("bulname") : '%';   //별명
    const valueuLisabun = evValue.get("ulisabun") ? evValue.get("ulisabun") : '%'; //우리품번
    const valueCusitem = evValue.get("cusitem") ? evValue.get("cusitem") : '%';   //업체품번
    const valueCusname = evValue.get("cusname") ? evValue.get("cusname") : '%';    //품명

    //console.log(valueCustomer,valueIpgodateStart,valueIpgodateEnd,valueBulname,valueuLisabun,valueCusitem,valueCusname);
    //console.log("업체코드:", valueCustomer);

    axios.get(`/IpgoReact/IndexSerche?valueCustomer=${valueCustomer}&valueIpgodateStart=${valueIpgodateStart}&valueIpgodateEnd=${valueIpgodateEnd}&valueBulname=${valueBulname}&valueuLisabun=${valueuLisabun}&valueCusitem=${valueCusitem}&valueCusname=${valueCusname}`)
      .then((res) => setData(res.data));
  };
  //날짜범위등록시작일
  const onDateStartChangeHandle = (dates, dateStrings) => {
    if (dates) {
      //console.log('From: ', dates[0], ', to: ', dates[1]);
      //console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
      setOnDateStart(dateStrings)
    } else {
      //console.log('Clear');
      setOnDateStart()
    }
  };
  //날짜범위등록종료일
  const onDateEndChangeHandle = (dates, dateStrings) => {
    if (dates) {
      //console.log('From: ', dates[0], ', to: ', dates[1]);
      //console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
      setOnDateEnd(dateStrings)
    } else {
      //console.log('Clear');
      setOnDateEnd()
    }
  };

  return (
    <>
      {/* //세션암호화 검증 */}
      {pwloading === urlpw ? (
        <div style={{ textAlign: "center" }}>
          {/* databases에 이미지 보여주기 */}
          {/* <img src={`data:image/jpeg;base64,${itemimg[0].file}`} alt="에라"/> */}

          <h3 style={{ paddingBottom: "10px", color: "blue" }}>입고등록현황</h3>
          {/* 폼입력자료 전송 */}
          <Box sx={{ ml: 3 }}>
            <Form onSubmit={handleSubmit} style={{ marginBottom: "10px" }}>
              <div className="input-group mb-12">
                {/* <SelectPicker
                  data={selectData}
                  onChange={(customername) => {
                    setValueSelectPicker(customername);
                  }}
                  style={{ width: 160, marginRight: 3, border: "1px solid #C0C0C0", borderRadius: 7 }}
                  placeholder="업체"
                /> */}
                <Autocomplete
                  options={selectData}
                  getOptionLabel={(option) => option.label || ""}
                  size="small"
                  style={{ width: 200, marginRight: 3 }}
                  value={valueSelectPicker ? valueSelectPicker : setValueSelectPicker('%')}
                  onChange={(event, newValue) => {
                    setValueSelectPicker(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} label="업체" variant="outlined" />}
                />
                <TextField
                  style={{ width: 130, marginRight: "2px", float: "center" }}
                  // margin="normal"
                  //required
                  variant="outlined"
                  size="small"
                  label="별명"
                  name="bulname"
                  autoComplete="bulname"
                />
                <TextField
                  style={{ width: 130, marginRight: "2px", float: "center" }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  size="small"
                  label="우리품번"
                  name="ulisabun"
                  autoComplete="ulisabun"
                />
                <TextField
                  style={{ width: 130, marginRight: "2px", float: "center" }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  size="small"
                  label="업체품번"
                  name="cusitem"
                  autoComplete="cusitem"
                  autoFocus
                />
                <TextField
                  style={{ width: 130, marginRight: "2px", float: "center" }}
                  //margin="normal"
                  //required
                  variant="outlined"
                  size="small"
                  label="품명"
                  name="cusname"
                  autoComplete="cusname"
                />

                <ConfigProvider locale={locale}>
                  <Space direction="vertical" size={12}>
                    <DatePicker
                      style={{
                        height: 38,
                        borderRadius: 4,
                        marginRight: 2,
                        width: "120px",
                      }}
                      placeholder="등록시작일"
                      onChange={onDateStartChangeHandle} //날짜범위시작일
                    />
                  </Space>
                </ConfigProvider>
                <ConfigProvider locale={locale}>
                  <Space direction="vertical" size={12}>
                    <DatePicker
                      style={{
                        height: 38,
                        borderRadius: 4,
                        marginRight: 6,
                        width: "120px",
                      }}
                      placeholder="등록종료일"
                      onChange={onDateEndChangeHandle} //날짜범위종료일
                    />
                  </Space>
                </ConfigProvider>

                <Button
                  type="submit"
                  variant="contained"
                  style={{
                    background: '#0277bd',
                    color: 'white',
                    height: 36,
                    width: 120,
                    marginRight: 3,
                    float: "center",
                  }}
                >
                  <i className="fa-solid fa-magnifying-glass" style={{ fontSize: '16px' }}></i>
                  조회
                </Button>
                <Button
                  variant="contained"
                  startIcon={<InsertDriveFileIcon />}
                  style={{
                    background: '#00838f',
                    color: 'white',
                    height: 36,
                    width: 120,
                    marginRight: 5,
                    float: "center",
                  }}
                  onClick={() => {
                    setAdd(true);
                  }}
                >
                  등록
                </Button>
                <Button
                  id="homemove"
                  variant="contained"
                  startIcon={<HomeIcon />}
                  style={{
                    background: '#004d40',
                    color: 'white',
                    height: 36,
                    width: 120,
                    float: "center",
                  }}
                  onClick={() => {
                    window.location.href = "/home/index";
                  }}
                >
                  홈이동
                </Button>
              </div>
            </Form>
          </Box>
          <Container maxWidth="xl">
            <Box style={{ border: "1px solid", borderColor: "#42a5f5", borderRadius: "1px" }}>
              <Grid
                columns={columns}
                data={rows}
                summary={summary}
                //scrollX={false}
                scrollY={false}
                rowHeight={"auto"}
                minRowHeight={30}
                //bodyHeight={650}
                bodyHeight={"auto"}
                heightResizable={true}
                //columnOptions= {{resizable: true}} //컬럼마우스조절가능
                //rowHeaders={['rowNum','checkbox']}
                virtualScrolling={true}
                rowHeaders={rowHeaders}
                usageStatistics={false} //전 세계적으로 TOAST UI Grid가 얼마나 널리 사용되고 있는지 파악 사용
                pageOptions={{ useClient: true, perPage: 20 }} // front에서만 페이징 하는 속성
                //pageOptions= {{perPage: 20}}
                //oneTimeBindingProps={['data', 'columns']} //무조건 재랜더링 방지
                columnOptions={{
                  minWidth: 50,
                  resizable: true,
                  frozenCount: 8,
                  frozenBorderWidth: 1,
                }}
                ref={gridRef}
                onClick={handleClick}
              />
            </Box>
            <Button size="small" onClick={getJsonLoad} style={{ fontSize: '14px', fontWeight: 'bold', color: '#003c80' }}>
              Today[오늘일자]
            </Button>
          </Container>
          {add === true ? (
            <IpgoCreate
              add={add}
              setAdd={setAdd}
              data={data}
              setData={setData}
              setDbOpen={setDbOpen}
              setEerror={setEerror}
              setEsave={setEsave}
            />
          ) : null}

          {editmodal === true ? (
            <IpgoEdit
              editmodal={editmodal}
              setEditModal={setEditModal}
              data={data}
              setData={setData}
              editValue={editValue}
              setDbOpen={setDbOpen}
              setEerror={setEerror}
              setEsave={setEsave}
            />
          ) : null}
          {delmodal === true ? (
            <IpgoDelete
              delmodal={delmodal}
              setDelmodal={setDelmodal}
              data={data}
              setData={setData}
              editValue={editValue}
              setEditValue={setEditValue}
              setDbOpen={setDbOpen}
              setEerror={setEerror}
              setEsave={setEsave}
            />
          ) : null}
          {eerror === true ? (
            <IpgoError eerror={eerror} setEerror={setEerror} />
          ) : null}
          {esave === true ? (
            <IpgoEsave esave={esave} setEsave={setEsave} />
          ) : null}
        </div>
      ) : urlExquate()}
    </>
  );

}

export default React.memo(IpgoIndex)
